const getters = {
  token: state => state.user.token,
  educationmaninfo: state => state.app.educationmaninfo,
}
export default getters
